/** Business contact info shown across the site. */
export const PHONE_NUMBER = '407-271-5301';
export const PHONE_HREF = `tel:${PHONE_NUMBER.replace(/-/g, '')}`;
export const CONTACT_EMAIL = 'info@kingdomstrollers.com';
